export default {
  'Please select an output format': 'Por favor, selecione um formato de saída',
}